import { PermissionContext } from './context';
import {
    PLAN_LEVEL_MAP,
    PLAN_LEVELS,
    SUBSCRIPTION_PERMISSIONS,
    SUBSCRIPTION_PERMISSIONS_YEARLY,
    SUBSCRIPTION_PERMISSIONS_UNLIMITED
} from './permission';

const PermissionProvider = ({ permissions, planLevel = PLAN_LEVELS.FREE, children }) => {
    const isAllowedTo = (permission) => {
        const hasBasePermission = permissions.includes(permission);
        if (permission in SUBSCRIPTION_PERMISSIONS) {
            return SUBSCRIPTION_PERMISSIONS[permission].includes(planLevel);
        }

        return hasBasePermission;
    };

    const checkPlanLevel = (requiredLevel) => {
        return PLAN_LEVEL_MAP[planLevel] >= PLAN_LEVEL_MAP[requiredLevel];
    };

    const isBusinessOrAbove = () => {
        return checkPlanLevel(PLAN_LEVELS.BUSINESS);
    };

    const isCreatorOrAbove = () => {
        return checkPlanLevel(PLAN_LEVELS.CREATOR);
    };

    const isCreator = () => {
        return PLAN_LEVEL_MAP[planLevel] === PLAN_LEVEL_MAP[PLAN_LEVELS.CREATOR];
    };

    const isBusiness = () => {
        return PLAN_LEVEL_MAP[planLevel] === PLAN_LEVEL_MAP[PLAN_LEVELS.BUSINESS];
    };

    const isYearly = () => {
        return permissions.includes(SUBSCRIPTION_PERMISSIONS_YEARLY);
    };

    const isUnlimited = () => {
        return permissions.includes(SUBSCRIPTION_PERMISSIONS_UNLIMITED);
    };

    return (
        <PermissionContext.Provider value={{
            isAllowedTo,
            planLevel,
            checkPlanLevel,
            isBusinessOrAbove,
            isCreatorOrAbove,
            isCreator,
            isBusiness,
            isYearly,
            isUnlimited
        }}>
            {children}
        </PermissionContext.Provider>
    );
};

export default PermissionProvider;